module.exports = {
  footerText: 'SEQWENCE SYSTEMS INC © '+ new Date().getFullYear()
};
